// Helpers
function throttle(fn, limit) {
  let lastCall = 0;
  let timeout;

  return function (...args) {
    const now = Date.now();
    const remaining = limit - (now - lastCall);

    if (remaining <= 0) {
      clearTimeout(timeout);
      lastCall = now;
      fn.apply(this, args);
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        lastCall = Date.now();
        fn.apply(this, args);
      }, remaining);
    }
  };
}

document.addEventListener("DOMContentLoaded", function () {
  // Quantity selector
  const quantityInput = document.querySelector('input[name="quantity"]');
  const minusBtn = document.querySelector(".quantity-selector__minus");
  const plusBtn = document.querySelector(".quantity-selector__plus");

  if (quantityInput && minusBtn && plusBtn) {
    minusBtn.addEventListener("click", () => {
      const current = parseInt(quantityInput.value, 10) || 1;
      if (current > 1) {
        quantityInput.value = current - 1;
      }
    });

    plusBtn.addEventListener("click", () => {
      const current = parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = current + 1;
    });
  }

  // ajax cart
  const ajaxCart = document.querySelector(".ajax-cart");

  if (ajaxCart) {
    // Open via cart links
    const headerCount = document.querySelector(".header__cart-count");
    const cartUrl = ajaxCart.getAttribute("data-url");
    const cartChangeUrl = ajaxCart.getAttribute("data-change-url");
    const cartLinks = document.querySelectorAll(`a[href="${cartUrl}"]`);
    const productForms = document.querySelectorAll(
      ':not(.ajax-cart) form[action^="/cart/add"]'
    );

    cartLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        ajaxCart.classList.toggle("ajax-cart--active");
        const header = document.querySelector("header");
        if (header) header.classList.toggle("header--nav-active");
      });
    });

    document.addEventListener("click", (e) => {
      const isClickInsideCart = ajaxCart.contains(e.target);
      const isCartLink = e.target.closest('a[href^="/cart"]');

      if (!isClickInsideCart && !isCartLink) {
        ajaxCart.classList.remove("ajax-cart--active");
        const header = document.querySelector("header");
        if (header) header.classList.remove("header--nav-active");
      }
    });

    productForms.forEach((form) => {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();

        const formData = new FormData(form);
        let actionUrl = form.action;
        if (!actionUrl.endsWith(".js")) {
          actionUrl = actionUrl.replace("/cart/add", "/cart/add.js");
        }

        try {
          ajaxCart.classList.add("ajax-cart--busy");
          ajaxCart.classList.add("ajax-cart--active");

          const res = await fetch(actionUrl, {
            method: "POST",
            body: formData,
          });

          if (!res.ok) throw new Error("Failed to add to cart");

          await updateCart();
        } catch (err) {
          console.error("❌ AJAX form error:", err);
          ajaxCart.classList.remove("ajax-cart--busy");
        }
      });
    });

    function setDynamicCartListeners() {
      const ajaxCartRemoves = document.querySelectorAll(
        ".ajax-cart-item__content-remove"
      );

      // Remove links
      ajaxCartRemoves.forEach((el) => {
        el.addEventListener("click", async (e) => {
          e.preventDefault();

          // Make sure we have an item key
          const itemKey = el.getAttribute("data-key");
          if (!itemKey) return;

          // Set the busy state
          ajaxCart.classList.add("ajax-cart--busy");

          try {
            // Remove the item
            await fetch(cartChangeUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: itemKey,
                quantity: 0,
              }),
            });

            // Update the cart content
            await updateCart();
          } catch (err) {
            console.log(err);
            ajaxCart.classList.remove("ajax-cart--busy");
          }
        });
      });
    }

    async function updateCart() {
      // Fetch a new cart
      const newHeaderRaw = await fetch("/?section_id=header");
      const newHeaderText = await newHeaderRaw.text();
      const newHeader = document.createElement("div");
      newHeader.innerHTML = newHeaderText;
      const newCart = newHeader.querySelector(".ajax-cart");
      if (!newCart) return;

      // Update item count
      const newCartCount = newCart.getAttribute("data-count");
      if (headerCount) headerCount.textContent = newCartCount;

      // Update the content
      ajaxCart.innerHTML = newCart.innerHTML;

      // Add the event listeners
      setDynamicCartListeners();

      // Remove busy state
      ajaxCart.classList.remove("ajax-cart--busy");
    }

    setDynamicCartListeners();
  }

  // Sticker rotation
  function rotateOnScroll() {
    const elements = document.querySelectorAll(".scroll-rotate");
    const windowHeight = window.innerHeight;

    elements.forEach((el) => {
      const rect = el.getBoundingClientRect();

      // Get midpoint of the element and calculate scroll ratio
      const midpoint = rect.top + rect.height / 2;
      const scrollRatio = (midpoint - windowHeight / 2) / (windowHeight / 2);

      // Clamp scrollRatio between -1 and 1
      const clamped = Math.max(-1, Math.min(scrollRatio, 1));

      // Read custom attributes
      const maxRotation = parseFloat(el.dataset.rotateMax) || 30;
      const direction = el.dataset.direction === "ccw" ? -1 : 1;

      // Apply transform
      const rotation = clamped * maxRotation * direction * 0.75;
      el.style.transform = `rotate(${rotation}deg)`;
    });
  }

  let ticking = false;

  function onScrollOrResize() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        rotateOnScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener("scroll", onScrollOrResize);
  window.addEventListener("resize", onScrollOrResize);
  rotateOnScroll();
});
